import React from 'react';

import QuickRulesControl from '@dndComponents/campaign/QuickRulesControl';

export default function Search() {
  return (
    <QuickRulesControl />
  );
}
